import script from "./AccountPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountPage.vue?vue&type=script&setup=true&lang=js"

import "./AccountPage.vue?vue&type=style&index=0&id=ef48e8ac&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef48e8ac"]])

export default __exports__